import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
import { makeStyles } from "@material-ui/core/styles";
import CIcon from "@coreui/icons-react";
import { freeSet } from "@coreui/icons";

const EmployeeList = ({ employees, handleServerUpdate }) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      position: "relative",
      overflow: "auto",
      maxHeight: "100%",
    },
    listSection: {
      backgroundColor: "inherit",
    },
    ul: {
      backgroundColor: "inherit",
      padding: 0,
    },
  }));

  const classes = useStyles();

  return (
    <List className={`${classes.root} h-100`} subheader={<li />}>
      {employees.map((employee, idx) => (
        <ListItem key={`item-${idx}-${employee}`} className="border-bottom">
          <ListItemText
            primary={`${employee.user.first_name} ${employee.user.last_name}`}
          />
          <CIcon
            content={freeSet.cilCloudDownload}
            customClasses="c-sidebar-nav-icon"
            onClick={() => handleServerUpdate([employee])}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default EmployeeList;
